/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { ErrorMessage } from '../model/errorMessage';
import { RequestInfo3 } from '../model/requestInfo3';
import { RequestInfo4 } from '../model/requestInfo4';
import { RequestInfo5 } from '../model/requestInfo5';
import { RequestInfo6 } from '../model/requestInfo6';
import { ResponseInfo2 } from '../model/responseInfo2';
import { ResponseInfo3 } from '../model/responseInfo3';
import { ResponseInfo4 } from '../model/responseInfo4';
import { ResponseInfo5 } from '../model/responseInfo5';
import { ResponseInfo6 } from '../model/responseInfo6';
import { ResponseInfo7 } from '../model/responseInfo7';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class IssueMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * OrgMgr_IssueMgr_IssueAssignment, Assign an issue
     * Assign an issues
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssueAssignmentPut(GroupId: number, Request: RequestInfo5, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo5>;
    public orgMgrIssueMgrV1IssueAssignmentPut(GroupId: number, Request: RequestInfo5, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo5>>;
    public orgMgrIssueMgrV1IssueAssignmentPut(GroupId: number, Request: RequestInfo5, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo5>>;
    public orgMgrIssueMgrV1IssueAssignmentPut(GroupId: number, Request: RequestInfo5, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssueAssignmentPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrIssueMgrV1IssueAssignmentPut.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ResponseInfo5>(`${this.basePath}/OrgMgr/IssueMgr/V1/Issue/Assignment`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_IssueMgr_RetrieveAllIssueDefinition, Retrieve all issue definition
     * Retrieve all issue definition
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssueDefinitionGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo2>;
    public orgMgrIssueMgrV1IssueDefinitionGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo2>>;
    public orgMgrIssueMgrV1IssueDefinitionGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo2>>;
    public orgMgrIssueMgrV1IssueDefinitionGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssueDefinitionGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseInfo2>(`${this.basePath}/OrgMgr/IssueMgr/V1/IssueDefinition`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_IssueMgr_RetrieveNote, Retrieve issue note by issue id
     * Retrieve issue note by issue id
     * @param IssueId Enter the IssueId for which Note needs to be retrieve
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssueIssueIdNoteGet(IssueId: number, GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo7>;
    public orgMgrIssueMgrV1IssueIssueIdNoteGet(IssueId: number, GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo7>>;
    public orgMgrIssueMgrV1IssueIssueIdNoteGet(IssueId: number, GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo7>>;
    public orgMgrIssueMgrV1IssueIssueIdNoteGet(IssueId: number, GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (IssueId === null || IssueId === undefined) {
            throw new Error('Required parameter IssueId was null or undefined when calling orgMgrIssueMgrV1IssueIssueIdNoteGet.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssueIssueIdNoteGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseInfo7>(`${this.basePath}/OrgMgr/IssueMgr/V1/Issue/${encodeURIComponent(String(IssueId))}/Note`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_IssueMgr_IssueNote, Issue Note
     * Issue Note
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssueNotePost(GroupId: number, Request: RequestInfo6, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo6>;
    public orgMgrIssueMgrV1IssueNotePost(GroupId: number, Request: RequestInfo6, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo6>>;
    public orgMgrIssueMgrV1IssueNotePost(GroupId: number, Request: RequestInfo6, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo6>>;
    public orgMgrIssueMgrV1IssueNotePost(GroupId: number, Request: RequestInfo6, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssueNotePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrIssueMgrV1IssueNotePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo6>(`${this.basePath}/OrgMgr/IssueMgr/V1/Issue/Note`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_IssueMgr_CreateIssue, Create a issue
     * Create a issue
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssuePost(GroupId: number, Request: RequestInfo3, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo3>;
    public orgMgrIssueMgrV1IssuePost(GroupId: number, Request: RequestInfo3, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo3>>;
    public orgMgrIssueMgrV1IssuePost(GroupId: number, Request: RequestInfo3, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo3>>;
    public orgMgrIssueMgrV1IssuePost(GroupId: number, Request: RequestInfo3, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssuePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrIssueMgrV1IssuePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo3>(`${this.basePath}/OrgMgr/IssueMgr/V1/Issue`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_IssueMgr_RetrieveAllIssue, Retrieve all issue
     * Retrieve all issue
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrIssueMgrV1IssueRetrievePost(GroupId: number, Request: RequestInfo4, observe?: 'body', reportProgress?: boolean): Observable<ResponseInfo4>;
    public orgMgrIssueMgrV1IssueRetrievePost(GroupId: number, Request: RequestInfo4, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseInfo4>>;
    public orgMgrIssueMgrV1IssueRetrievePost(GroupId: number, Request: RequestInfo4, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseInfo4>>;
    public orgMgrIssueMgrV1IssueRetrievePost(GroupId: number, Request: RequestInfo4, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrIssueMgrV1IssueRetrievePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrIssueMgrV1IssueRetrievePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseInfo4>(`${this.basePath}/OrgMgr/IssueMgr/V1/Issue/Retrieve`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
